import React, { FC } from 'react'
import { IconSemiLogo } from '@douyinfe/semi-icons'
import { Layout } from '@douyinfe/semi-ui'
import useStore from '@src/store/common/global'

const { Footer } = Layout

const Index: FC = () => {
	const copyright = useStore((state) => state.copyright)
	return (
		<Footer
			style={{
				flexShrink: 0,
				height: '26px',
				display: 'flex',
				justifyContent: 'space-between',
				padding: '8px',
				color: 'var(--semi-color-text-2)',
				backgroundColor: 'rgba(var(--semi-grey-0), 1)'
			}}
		>
			<span
				style={{
					display: 'flex',
					alignItems: 'center'
				}}
			>
				<IconSemiLogo size="large" style={{ marginRight: '8px' }} />
				<span>{copyright.trim() || '© 2024 Plus-One UI. All rights reserved.'} </span>
			</span>
		</Footer>
	)
}

export default Index
